import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from 'src/app/shared/models/item.model';
import { PageType } from '../enums/page-type.enum';
import { PageModel } from '../model/page.model';
import { PagesService } from '../service/pages.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  pageType: PageType = PageType.Policy;
  result: PageModel = {} as any;
  isRTL: boolean;
  languageId: number = 2;

  constructor(private service: PagesService, private languageService: LanguageService) { }

  ngOnInit(): void {
    this.loadFaqsByLanguageId(this.languageId);
    console.log(this.languageId);
    this.onLangaugeChange();
  }

  onLangaugeChange()
  {
    this.languageService.languageChange.subscribe(res =>
      {
        this.isRTL = res === LanguageEnum.ar;
        if (!this.isRTL) { this.languageId = 1; } else { this.languageId = 2};
        this.loadFaqsByLanguageId(this.languageId);
      });
  }

  loadFaqsByLanguageId(id: number)
  {
    this.service.getPage(this.pageType).subscribe((result: any) => {
      if (id === 2)
      {
        this.service.getPage(this.pageType).subscribe((res: any) => {
          this.result.content = res.contentAr;
        })
      } else {
        this.service.getPage(this.pageType).subscribe((res: any) => {
          this.result.content = res.content;
        })
      }
    })
  }
}
